import React from "react";

function ScissorsLoader() {
  return (
    <div data-testid="scissors-loader" className="fixed inset-0 z-[9998] bg-[#0D0D0D] flex items-center justify-center">
      <svg
        width="48"
        height="48"
        viewBox="0 0 48 48"
        fill="none"
        className="scissors-anim"
      >
        {/* Top blade */}
        <g className="scissors-top">
          <ellipse cx="10" cy="10" rx="5" ry="5" stroke="#D4AF37" strokeWidth="1.5" fill="none" />
          <line x1="14" y1="13" x2="30" y2="26" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" />
        </g>
        {/* Bottom blade */}
        <g className="scissors-bottom">
          <ellipse cx="10" cy="38" rx="5" ry="5" stroke="#D4AF37" strokeWidth="1.5" fill="none" />
          <line x1="14" y1="35" x2="30" y2="22" stroke="#D4AF37" strokeWidth="1.5" strokeLinecap="round" />
        </g>
        {/* Pivot point */}
        <circle cx="24" cy="24" r="1.5" fill="#D4AF37" />
      </svg>
      <style>{`
        .scissors-anim .scissors-top {
          transform-origin: 24px 24px;
          animation: scissorTop 1.2s ease-in-out infinite;
        }
        .scissors-anim .scissors-bottom {
          transform-origin: 24px 24px;
          animation: scissorBottom 1.2s ease-in-out infinite;
        }
        @keyframes scissorTop {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(12deg); }
        }
        @keyframes scissorBottom {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(-12deg); }
        }
      `}</style>
    </div>
  );
}

export default ScissorsLoader;
